import { data } from 'yankees-react-utils';

const get = async (oktaToken, url, queryParams, fetchOpts) => data.get(url, queryParams, {
    ...fetchOpts,
    headers: { ...fetchOpts?.headers, Authorization: !oktaToken ? '' : `${oktaToken.tokenType} ${oktaToken.accessToken}` },
});
const post = async ({ tokenType, accessToken }, url, body, queryParams, fetchOpts) => data.post(url, body, queryParams, {
    ...fetchOpts,
    headers: { ...fetchOpts?.headers, Authorization: `${tokenType} ${accessToken}` },
});
const put = async ({ tokenType, accessToken }, url, body, queryParams, fetchOpts) => data.put(url, body, queryParams, {
    ...fetchOpts,
    headers: { ...fetchOpts?.headers, Authorization: `${tokenType} ${accessToken}` },
});
const remove = async ({ tokenType, accessToken }, url, queryParams, fetchOpts) => data.remove(url, queryParams, {
    ...fetchOpts,
    headers: { ...fetchOpts?.headers, Authorization: `${tokenType} ${accessToken}` },
});

const Config = {
    get: (t) => get(t, '/api/configuration'),
};

const User = {
    get: (t) => get(t, '/api/user'),
    login: ({ username, password }) => data.post('/api/login', null, null, {
        body: new URLSearchParams({ username, password }),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }),
};

const Advance = {
    ctwb: (t, params) => get(t, '/api/advance/ctwb', params),
    overview: (t, params) => get(t, '/api/advance/overview', params),
    oart: (t, params) => get(t, '/api/advance/oart', params),
    playerOart: (t, playerId, yearId) => get(t, `/api/advance/oart/${playerId}/${yearId}`),
    pitchMixOptimizationIndy: (t, params) => get(t, '/api/advance/pitchmixoptimizationindy', params),
    oppleads: (t, params) => get(t, '/api/advance/oppleads', params),
    stag: (t, params) => get(t, '/api/advance/stag', params),
    pickoff: (t, params) => get(t, '/api/advance/pickoff', params),
    pitchout: (t, params) => get(t, '/api/advance/pitchout', params),
    pastmatchup: (t, params) => get(t, '/api/advance/pastmatchups', params),
    matchupatbats: (t, params) => get(t, '/api/advance/matchupatbats', params),
    dfpo: (t, params) => get(t, '/api/advance/dfpo', params),
    pitcherOverview: (t, params) => get(t, '/api/advance/pitcheroverview', params),
};

const Approach = {
    getsaved: (t, params) => get(t, '/api/approach/getsaved', params),
    update: (t, params) => post(t, '/api/approach/update', params),
    delete: (t, approachid) => remove(t, `/api/approach/delete/${approachid}`),
};

const Ballcap = {
    getPlayerSessions: (t, playerid) => get(t, `/api/ballcap/${playerid}/sessions`),
    getSession: (t, playerid, sessionid) => get(t, `/api/ballcap/${playerid}/${sessionid}`),
    getSessionV2: (t, playerid, sessionid) => get(t, `/api/ballcap/${playerid}/session/${sessionid}`),
    getTrackmanPen: (t, playerid, sessionid) => get(t, `/api/ballcap/${playerid}/trackmanpen/${sessionid}`),
};

const BarrelBox = {
    query: (t, params) => get(t, '/api/barrel-box/query', params),
};

const Biomechanics = {
    getDaySummariesForPositionPlayer: (t, playerId) => get(t, `/api/biomechanics/position-player/${playerId}/day-summaries`),
    getDaySummaryForPositionPlayer: (t, { playerId, daySummaryId }) => get(t,
        `/api/biomechanics/position-player/${playerId}/day-summaries/${daySummaryId}`),
    getDaySummariesForPitcher: (t, playerId) => get(t, `/api/biomechanics/pitcher/${playerId}/day-summaries`),
    getDaySummaryForPitcher: (t, { playerId, daySummaryId }) => get(t, `/api/biomechanics/pitcher/${playerId}/day-summaries/${daySummaryId}`),
};

const Definitions = {
    get: (t, statistic) => get(t, `/api/definitions/${statistic}`),
};

const Game = {
    get: (t, gameid) => get(t, `/api/game/${gameid}`),
    byplayerstats: (t, { playerId, yearId, gameId }) => get(
        t,
        '/api/game/gamesbyplayerstats',
        { playerId, yearId, gameId },
    ),
    homepage: (t, { gameid }) => get(t, `/api/game/${gameid}/homepage`),
    upcoming: (t, params) => get(t, '/api/game/upcoming', params),
    upcomingSeries: (t, params) => get(t, '/api/game/upcomingSeries', params),
    batteries: (t, gameid, params) => get(t, `/api/game/${gameid}/batteries`, params),
    season: (t, { playerId, position }) => get(t, '/api/game/season', { playerId, position }),
    swingdecisions: (t, { playerid, gameid, include30 }) => get(t, `/api/game/${gameid}/swing-decisions/${playerid}`, { include30 }),
    nextseries: (t, params) => get(t, '/api/game/nextseries', params),
    batters: (t, gameid, params) => get(t, `/api/game/${gameid}/batters`, params),
};

const GameReport = {
    get: (t, gameId, teamId) => get(t, `/api/gamereport/${gameId}/${teamId}`),
    queryCatcherReviewPitch: (t, gameid) => get(t, '/api/gamereport/catcherreviewpitch', { gameid }),
    addCatcherReviewPitch: (t, pitch) => post(t, '/api/gamereport/catcherreviewpitch', pitch),
    deleteCatcherReviewPitch: (t, pitch) => post(t, '/api/gamereport/catcherreviewpitch/delete', pitch),
};

const HeatMaps = {
    getPitcherHeatMaps: (t, pitcherId, version = 2) => get(t, `/api/heatmaps/pitcher/${version}/${pitcherId}`),
    getBatterHeatMapsByPitchType: (t, batterId, params) => get(t, `/api/heatmaps/batter/pitchtype/${batterId}`, params),
    getBatterSwingMapsByPitchType: (t, batterId, params) => get(t, `/api/heatmaps/batterswings/pitchtype/${batterId}`, params),
    catcherWristband: (t, pitcherId, batterId, year, params) => get(t, `/api/heatmaps/catcherwristband/${pitcherId}/${batterId}/${year}`, params),
    pitchLocationActual: (t, pitcherId, params) => get(t, `/api/heatmaps/pitchlocationactual/${pitcherId}`, params),
    search: (t, params) => get(t, '/api/heatmaps/search', params),
    damageZones: (t, batterId, params) => get(t, `/api/heatmaps/batter/damagezones/${batterId}`, params),
};

const KeyTakeaway = {
    getByPlayer: (t, playerid) => get(t, `/api/keytakeaways/${playerid}`),
    getByTeam: (t, teamid) => get(t, `/api/keytakeaways/team/${teamid}`),
};

const Levels = {
    get: (t, params) => get(t, '/api/levels', params),
};

const Login = {
    getVersion: (t) => get(t, '/api/login/version'),
};

const MLBAMLiveFeed = {
    gameFeed: (t, gamepk, params) => get(t, `/api/mlbamlive/${gamepk}`, params),
    statcastPlays: (t, gamepk, params) => get(t, `/api/mlbamlive/${gamepk}/guids`, params),
    classifyPitches: (t, pitches) => post(t, '/api/mlbamlive/classify', pitches),
};

const Notes = {
    getReportNote: (t, { type, ...rest }) => get(t, `/api/notes/report/${type}`, rest),
    getReportNoteHistory: (t, { NoteID }) => get(t, `/api/notes/report/${NoteID}/history`),
    saveReportNote: (t, note) => post(t, '/api/notes/report', note),
};

const OutfieldThrow = {
    query: (t, params) => get(t, '/api/outfieldthrow', params),
};

const PitchTipping = {
    getNotes: (t, playerId) => get(t, `/api/pitchtipping/${playerId}/notes`),
};

const PitcherRepertoire = {
    get: (t, playerid, levelid) => get(t, '/api/pitcherrepertoire', { playerid, levelid }),
    // getLegacy: (t, playerid, levelid) => get(t, '/api/pitcherrepertoire/legacy', { playerid, levelid }),
};

const Player = {
    get: (t, { playerId }) => get(t, `/api/player/${playerId}`),
    list: (t, params) => get(t, '/api/player', params),
    orgrosterteam: (t, playerId) => get(t, `/api/player/${playerId}/orgrosterteam`),
    getRmb: (t, { playerId }) => get(t, `/api/player/${playerId}/rmb`),
    getReportYearsPitching: (t, playerId) => get(t, `/api/player/${playerId}/reportyearspitching`),
};

const PlayerReport = {
    // preportthresholds: (t, { playerId, ...rest }) => get(t, `/api/playerreport/${playerId}/preportthresholds`, rest),
    ppfx: (t, { playerId, ...rest }) => get(t, `/api/playerreport/${playerId}/ppfx`, rest),
    ppfxavgs: (t, { playerId, ...rest }) => get(t, '/api/playerreport/ppfx/avgs', rest),
    pitchcharacteristics: (t, { playerId, ...rest }) => get(t, `/api/playerreport/${playerId}/pitchcharacteristics`, rest),
    pitchlocation: (t, playerId) => get(t, `/api/playerreport/${playerId}/pitchlocation`),
    ptbfxdrilldown: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/ptbfxdrilldown`, rest),
    ptbfxdrilldownpitches: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/ptbfxdrilldownpitches`, rest),
    adov: (t, { playerId, ...rest }) => get(t, `/api/playerreport/${playerId}/adov`, rest),
    pts: (t, playerId, params) => get(t, `/api/playerreport/${playerId}/pts`, params),
    pitchlocationactual: (t, playerId, params) => get(t, `/api/playerreport/${playerId}/pitchlocationactual`, params),
    recv: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/recv`, rest),
    recvdepthlocation: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/recvdepthlocations`, rest),
    blok: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/blok`, rest),
    bloknondirt: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/blok/nondirtballs`, rest),
    spraychart: (t, { playerId, ...rest }) => get(t, '/api/playerreport/spraychart', rest),
    hitmonNtiles: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/hitmon_ntiles`, rest),
    hitmonPitches: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/hitmon-pitches`, rest),
    hitmonLevelAverages: (t, params, fetchOpts) => post(t, '/api/playerreport/hitmon-level-averages', params, null, fetchOpts),
    hitmonTrends: (t, { playerid, ...rest }) => get(t, `/api/playerreport/${playerid}/hitmon-trends`, rest),
    // pitcheroverview: (t, { pitcherId, ...rest }) => get(t, `/api/playerreport/${pitcherId}/pitcheroverview`, rest),
    timethroughorder: (t, { pitcherId, ...rest }) => get(t, `/api/playerreport/${pitcherId}/timethroughorder`, rest),
    lastXAppearances: (t, { pitcherId, ...rest }) => get(t, `/api/playerreport/${pitcherId}/lastxappearances`, rest),
    inGameSpeed: (t, playerId, params) => get(t, `/api/playerreport/in-game-speed/${playerId}`, params),
    hitterBatTracking: (t, playerId, params) => get(t, `/api/playerreport/${playerId}/hitter-bat-tracking`, params),
};

const PlayerDevObjectives = {
    get: (t, params) => get(t, '/api/pdobjectives', params),
    getObjectiveMetric: (t, objectiveId, objectiveMetricId) => get(t, `/api/pdobjectives/${objectiveId}/metric/${objectiveMetricId}`),
};

const PlayerSettings = {
    get: (t, playerId, isMlb, isPitcher) => get(t, `/api/player-settings/${playerId}`, { isMlb, isPitcher }),
    update: (t, playerSetting, isMlb, isPitcher) => post(t, '/api/player-settings', playerSetting, { isMlb, isPitcher }),
};

const Playlists = {
    getPlayerPlaylist: (t, playerId) => get(t, `/api/playlists/${playerId}`),
    getDatePlaylists: (t, playerId, date) => get(t, `/api/playlists/${playerId}`, { playlistdate: date }),
    getTeamPlaylist: (t, playerId, teamId) => get(t, `/api/playlists/${playerId}/team/${teamId}`),
    getOppsoingPlayerPlaylist: (t, playerId, opposingPlayerId) => get(t, `/api/playlists/${playerId}/opposing-player/${opposingPlayerId}`),
    playlistCategories: (t) => get(t, '/api/playlists/playlistcategories'),
};

const Search = {
    players: (t, searchParams) => get(t, '/api/search/players', searchParams),
    teams: (t, searchParams) => get(t, '/api/search/teams', searchParams),
};

const Schedule = {
    getUpcomingSchedule: (t, params) => get(t, '/api/schedule/upcoming', params),
};

const Stats = {
    pitchtypebreakdownpitchfxaverages: (t, { islhb = false, islhp = false }) => get(t, '/api/stats/pitchtypebreakdownpitchfxaverages', { islhb, islhp }),
    pSplits: (t) => get(t, '/api/stats/splits/pitching'),
    pitchbreaks: (t, { playerid, yearid, ...rest }) => get(t, '/api/stats/season/pitching/breaks', { playerid, yearid, ...rest }),
    catcherThrows: ((t, params) => get(t, '/api/stats/catcherthrows', params)),
    catcherCharts: ((t, params) => get(t, '/api/stats/catchercharts', params)),
    pitchtypebreakdownpitchfxzscore: ((t, params) => get(t, '/api/stats/pitchtypebreakdownpitchfxzscore', params)),
    seasonBatting: (t, { playerid, ...rest }) => get(t, '/api/stats/season/batting', { playerid, ...rest }),
    seasonPitching: (t, { playerid, ...rest }) => get(t, '/api/stats/season/pitching', { playerid, ...rest }),
    fplayLogs: (t, { playerid, gameid }) => get(t, `/api/stats/fplaylogs?playerid=${playerid}&gameid=${gameid}`),
    currentLevelAvgs: (t, levelid) => get(t, '/api/stats/levelaverages/current', { levelid }),
    pitches: (t, playerId, fromYear) => get(t, `/api/stats/${playerId}/pitches`, { fromYear }), // NOTE this is ONLY for ballcap
    percentiles: (t, { pitchType, levelid, yearid }) => get(t, '/api/stats/percentiles', { pitchType, levelid, yearid }), // ONLY for ballcap
    breakplots: (t, playerid, pitchType) => get(t, '/api/stats/breakplots', { playerid, pitchType }), // ONLY for ballcap,
    bSeasonSplits: (t, { playerid, splitid, yearid, ...rest }) => get(t, '/api/stats/season/batting/splits', { playerid, splitid, yearid, ...rest }),
};

const StrikeZones = {
    getStrikeZoneContours: (t, { ...rest }) => get(t, '/api/strikezone/contour', rest),
};

const Team = {
    get: (t, teamId) => get(t, `/api/team/${teamId}`),
    bylevel: (t, levelId) => get(t, `/api/team/bylevel/${levelId}`),
    minormajor: (t, teamId) => get(t, `/api/team/${teamId}/minormajor`),
    lineup: (t, teamId, isBattingLineup, params) => get(t, `/api/team/${teamId}/lineup`, { ...params, type: isBattingLineup ? 0 : 1 }),
    loginroster: (t, teamId, params) => get(t, `/api/team/${teamId}/loginroster`, { ...params }),
    dugoutOpponents: (t) => get(t, '/api/team/dugoutopponents'), // note: only for use in offline mode
};

const UserReport = {
    post: (t, formData) => post(t, '/api/userreport/web', formData),
};

const Video = {
    getPitch: (t, gameid, eventseq, pitchseq) => get(t, '/api/video', { gameid, eventseq, pitchseq }),
    search: (t, searchParams, fetchOpts) => get(t, '/api/video/search', { ...searchParams, useimputeddata: true }, fetchOpts),
    data: (t, params) => get(t, '/api/video/data', { ...params, useimputeddata: true }),
    multi: (t, params) => post(t, '/api/video/multi', params),
};

const VideoSearch = {
    get: (t) => get(t, '/api/videosearch'),
    create: (t, videoSearch) => post(t, '/api/videosearch', videoSearch),
    update: (t, videoSearchId, videoSearch) => put(t, `/api/videosearch/${videoSearchId}`, videoSearch),
    delete: (t, videoSearchId) => remove(t, `/api/videosearch/${videoSearchId}`),
};

const Years = {
    get: (t, params) => get(t, '/api/years', params),
};

const PitcherStrengths = {
    getOverview: (t, { pitcherId, ...params }) => get(t, `/api/pitcher-strengths/${pitcherId}/overview`, params),
    getPitchBreakdown: (t, { pitcherId, ...params }) => get(t, `/api/pitcher-strengths/${pitcherId}/pitchbreakdown`, params),
};

const HitterStrengths = {
    getBatTracking: (t, playerId, params) => post(t, `/api/hitter-strengths/${playerId}/bat-tracking`, params),
};

const PitchingBreakdown = {
    getPitchComparison: (t, params) => post(t, '/api/pitchingbreakdown/comparison', params),
    getBatTracking: (t, params) => post(t, '/api/pitchingbreakdown/bat-tracking', params),
    pitchmonPitches: (t, playerId, params, opts) => get(t, `/api/pitchingbreakdown/${playerId}/pitchmon-pitches`, params, opts),
    pitchmonLevelAverages: (t, params, opts) => post(t, '/api/pitchingbreakdown/pitchmon-level-averages', params, null, opts),
};

export {
    Config,
    User,
    Years,
    Levels,
    Approach,
    PlayerReport,
    Game,
    GameReport,
    Player,
    Stats,
    Video,
    PitchTipping,
    Notes,
    HeatMaps,
    StrikeZones,
    VideoSearch,
    Search,
    Team,
    PitcherRepertoire,
    Advance,
    OutfieldThrow,
    Definitions,
    PlayerDevObjectives,
    Schedule,
    PlayerSettings,
    Playlists,
    Ballcap,
    UserReport,
    Login,
    KeyTakeaway,
    Biomechanics,
    BarrelBox,
    MLBAMLiveFeed,
    PitcherStrengths,
    HitterStrengths,
    PitchingBreakdown,
};
